import { Link } from 'react-router-dom';

import { Logo } from '@/components/common/Logo';
import { ForgetPasswordForm } from '@/components/forms/auth/ForgetPasswordForm';

const ForgetPassword = ({
  isInternalHostname,
}: {
  isInternalHostname: boolean;
}) => {
  return (
    <div className="mx-auto flex min-h-full w-full max-w-[400px] flex-col justify-center px-4 max-sm:items-center lg:w-1/2">
      <div className="flex">{isInternalHostname && <Logo />}</div>
      <h2 className="as-strong mb-6 mt-10 text-black">Forgot your Password?</h2>
      <ForgetPasswordForm />
      <div className="my-4 flex items-center">
        <div className="h-[1px] w-full bg-neutral-200" />
        <Link
          to={`/${window.localStorage.getItem('active-org-id')}/auth/sign-in`}
          className="as-body-03 w-full text-center text-muted-foreground underline hover:text-black"
        >
          Sign in
        </Link>
        <div className="h-[1px] w-full bg-neutral-200" />
      </div>
    </div>
  );
};

export { ForgetPassword };
